




































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import PerformanceWidget from '@/components/organisms/Performance/PerformanceWidget/index.vue';
import PerformanceGroupedBarWeeksDiagram from '@/components/organisms/Performance/PerformanceGroupedBarWeeksDiagram/index.vue';
import NightlyRatesMarker
  from '@/components/organisms/Performance/PerformanceWidget/PerformanceWidgetNightlyRates/NightlyRatesMarker/index.vue';
import NightlyRatesLine
  from '@/components/organisms/Performance/PerformanceWidget/PerformanceWidgetNightlyRates/NightlyRatesLine/index.vue';

@Component({
  name: 'PerformanceWidgetRegionBookings',
  components: {
    PerformanceWidget,
    PerformanceGroupedBarWeeksDiagram,
    NightlyRatesMarker,
    NightlyRatesLine,
  },
})
export default class PerformanceWidgetRegionBookings extends Vue {
  @Prop() protected loading!: any;

  @Prop() protected currency!: any;

  @Prop() protected trends!: any;

  @Prop() protected marketLabel!: any;

  @Prop() protected values!: any;

  @Prop() protected hasError!: boolean;

  @Prop() protected lineMarker!: any;

  protected types = [
    {
      title: 'Bookings',
      shortTitle: 'Bookings',
    },
  ];
}
